<script>
	import CmsImage from '$lib/components/cms-image.svelte';
	import Seo from '$lib/components/seo.svelte';
	import { displayLanguage, humanizeDate, t } from '$lib/i18n/translation';

	export let data;
</script>

<Seo title="news.title" description="news.description"></Seo>

<div class="container py-20">
	<div class="prose lg:prose-xl mb-16">
		<h1>{$t('news.headline')}</h1>
	</div>

	<div class="grid gap-16 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3">
		{#each data.news as newsArticle}
			<a href={`/news/${newsArticle.Slug}`} class="card bg-base-100 border border-base-200 w-full shadow-lg">
				<figure>
					{#if newsArticle.Teaser && newsArticle.Teaser?.data !== null}
						<CmsImage cmsData={newsArticle.Teaser} format={'small'} cssClass="object-cover w-full h-[200px]" />
					{/if}
				</figure>

				<div class="card-body prose">
					<h2 class="mb-0">{newsArticle.Headline}</h2>
					<small>{humanizeDate(new Date(newsArticle.publishedAt), $displayLanguage)}</small>
					<p>{newsArticle.ShortDescription}</p>
					<div class="card-actions justify-end">
						<a href={`/news/${newsArticle.Slug}`} class="btn btn-secondary">{$t('news.button_link')}</a>
					</div>
				</div>
			</a>
		{/each}
	</div>
</div>
